let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let DbRecorder = require("../recorder/DbRecorder.js");
let i18n = require("./i18n");
let POS = require("../POS.js");

let main = function ($, _, Backbone, DbRecorder, i18n, POS) {
    return (function () {
        var root = this;
        var previousPrinterUtil = root.PrinterUtil;
        var PrinterUtil = root.PrinterUtil = {};

        PrinterUtil.formats = {};

        PrinterUtil.defaults = {};

        PrinterUtil.actions = {};

        var CONST = {
            ZERO: 0, ONE: 1, TWO: 2, LF: 10, FF: 12,
            ESC: 27, GS: 29, SPACE: 32, COLON: 58,
            SEVENTEEN: 17, EXCLAMATION: 33,
            line: 45, AT: 64, M: 66, V: 86, a: 97,
            LINESPACE: 51,TAGSPACE:40
        };


        var parseWidth = function (str, font) {
            if (_.isUndefined(str)) {
                return 0;
            }
            if (_.isNull(str)) {
                return 0;
            }
            if (str === '') {
                return 0;
            }

            var width = 0, level = 1, pos, c;
            switch (font) {
                case "large":
                    level = 2;
                    break;
                default :
                    level = 1;
                    break;
            }
            if (_.isNumber(str)) {
                str = str + "";
            }
            for (pos = 0; pos < str.length; pos++) {
                c = str.charCodeAt(pos);
                if (c >= 0 && c <= 127) {
                    width += level;
                } else {
                    width += 2 * level;
                }
            }
            return width;
        };

        var paperCut = function (array) {
            array.push(CONST.ESC, CONST.AT, CONST.GS, CONST.V, CONST.M, CONST.ZERO);
        };

        var openCashierDrawer = function (socketId, array) {
            array.push([CONST.ESC, CONST.AT, CONST.ESC, 112, 0, 64, 240]);
        };

        var printBuffer = function (array) {
            array.push(CONST.FF)
        };

        var lineFeed = function (array) {
            array.push(CONST.LF);
        };

        var largeFont = function (array) {
            array.push(CONST.GS, CONST.EXCLAMATION, CONST.SEVENTEEN);
        };

        var defaultFont = function (array) {
            array.push(CONST.GS, CONST.EXCLAMATION, CONST.ZERO);
        };
        /**
         * 标签打印机部分
         */
        var arrayToLabelArray = function (array, code) {
            if(_.isNumber(code)){
                code = code.toString();
            }
            if(_.isArray(code)){
                array = array.concat(code);
                return array;
            }
            for (var x = 0; x < code.length; x++) {
                array.push(code.charCodeAt(x));
            }
            return array;
        };

        //设置纸张宽度
        var setSize = function (array, width, height) {
            array.push(83, 73, 90, 69, 32);
            array = arrayToLabelArray(array, width);
            array.push(32, 109, 109, 44);
            array = arrayToLabelArray(array, height);
            array.push(32, 109, 109, 10);
        };

        //设置纸张间隙
        var setGap = function (array, gap) {
            array.push(71, 65, 80, 32);
            array = arrayToLabelArray(array, gap);
            array.push(32, 109, 109, 44, 48, 10);
        };

        //设置出纸时间
        var setSpeed = function (array, speed) {
            array.push(83, 80, 69, 69, 68, 32, 54, 10);
        };

        //设置打印浓度
        var setDensity = function (array, density) {
            array.push(68, 69, 78, 83, 73, 84, 89, 32, 56, 10);
        };

        //设置打印方向
        var setDirection = function (array, direction) {
            array.push(68, 73, 82, 69, 67, 84, 73, 79, 78, 32, 48, 10);
        };
        //撕离模式关闭
        var setTearOff = function (array, auto) {
            if (auto) {
                array.push(83, 69, 84, 32, 84, 69, 65, 82, 32, 79, 70, 70, 10);
            } else {
                array.push(83, 69, 84, 32, 84, 69, 65, 82, 32, 79, 78, 10);
            }
        };
        //撕离感应开启
        var setPeelOn = function (array, auto) {
            if (auto) {
                array.push(83, 69, 84, 32, 80, 69, 69, 76, 32, 79, 78, 10);
            } else {
                array.push(83, 69, 84, 32, 80, 69, 69, 76, 32, 79, 70, 70, 10);
            }
        };

        //  清空缓存
        var CLS = function (array) {
            array.push(67, 76, 83, 10);
        };

        // printTitle
        var textTitle = function (array, title,level) {
            array.push(84, 69, 88, 84, 32,51, 48, 44);
            array = arrayToLabelArray(array,(level+1)*CONST.TAGSPACE);
            array.push(44, 34, 84, 83, 83, 50, 52, 46, 66, 70, 50, 34, 44, 48, 44, 49, 44, 49, 44, 34);
            array = array.concat(title);
            array.push(34, 10);
            return array;
        };

        // printContent
        var textContent = function (array, content,level) {
            array.push(84, 69, 88, 84, 32,51, 48, 44);
            array = arrayToLabelArray(array,(level+1)*CONST.TAGSPACE);
            array.push(44, 34, 84, 83, 83, 50, 52, 46, 66, 70, 50, 34, 44, 48, 44, 49, 44, 49, 44, 34);
            array = array.concat(content);
            array.push(34, 10);
            return array;
        };
        // printTags
        var textTags = function (array, content,level) {
            array.push(84, 69, 88, 84, 32,51, 48, 44);
            array = arrayToLabelArray(array,(level+1)*CONST.TAGSPACE);
            array.push(44, 34, 84, 83, 83, 50, 52, 46, 66, 70, 50, 34, 44, 48, 44, 49, 44, 49, 44, 34);
            _.each(content,function(tag,index){
                array = array.concat(tag);
                array.push(32);
            });
            array.push(34, 10);
            return array;
        };

        // print
        var printContent = function (array) {
            array.push(80, 82, 73, 78, 84, 32, 49, 44, 49, 10);
        };
        var defaultModel = function (array) {
            array.push(CONST.ESC, CONST.AT);
        };
        var center = PrinterUtil.formats.center = function (array) {
            array.push(CONST.ESC, CONST.a, CONST.ONE);
        };

        var right = PrinterUtil.formats.right = function (array) {
            array.push(CONST.ESC, CONST.a, CONST.TWO);
        };

        var left = PrinterUtil.formats.left = function (array) {
            array.push(CONST.ESC, CONST.a, CONST.ZERO);
        };

        var plusSpace = function (num, column) {
            num = Math.max(num, 1);
            for (var i = 0; i < num; i++) {
                column.push(CONST.SPACE);
            }
            return column;
        };

        var plusLine = function (width, array) {
            for (var i = 0; i < width; i++) {
                array.push(CONST.line);
            }
            lineFeed(array);
            return array;
        };

        var isSingle = function (c) {
            return (c < 128) && (c > -1);
        };

        var toBytes = function (value) {
            var toc = null;
            if (_.isObject(value)) {
                if (value.bytes) {
                    return JSON.parse(JSON.stringify(value.bytes));
                } else {
                    toc = value.text;
                }
            } else {
                toc = value;
            }
            var array = [];
            if (_.isNumber(toc)) {
                toc = toc + "";
            }
            for (var i = 0; i < toc.length; i++) {
                array.push(toc.charCodeAt(i));
            }
            return array;
        };

        var cutBytes = function (value, pos) {
            var result = {left: {text: "", bytes: []}, cut: {text: "", bytes: []}}, index, repos = 0, c;
            if (value.bytes) {
                for (index = 0; index < value.text.length; index++) {
                    c = value.text.charCodeAt(index);
                    if (isSingle(c)) {
                        if (repos < pos) {
                            result.left.text += value.text.substring(index, index + 1);
                            addArray2array(result.left.bytes, value.bytes.slice(repos, repos + 1));
                        } else {
                            result.cut.text = value.text.substring(index);
                            addArray2array(result.cut.bytes, value.bytes.slice(repos));
                            break;
                        }
                    } else {
                        if (repos < pos - 1) {
                            result.left.text += value.text.substring(index, index + 1);
                            addArray2array(result.left.bytes, value.bytes.slice(repos, repos + 2));
                        } else {
                            result.cut.text = value.text.substring(index);
                            addArray2array(result.cut.bytes, value.bytes.slice(repos));
                            break;
                        }
                        repos++;
                    }
                    repos++;
                }
            } else {
                for (index = 0; index < value.text.length; index++) {
                    c = value.text.charCodeAt(index);
                    if (repos < pos) {
                        result.left.text += value.text.substring(index, index + 1);
                        result.left.bytes.push(c);
                    } else {
                        result.cut.text += value.text.substring(index, index + 1);
                        result.cut.bytes.push(c);
                    }
                    repos++;
                }
            }
            return result;
        };

        var FORMATS = {
            TITLE: "title",
            LINE: "line",
            LEFT_RIGHT: "left_right",
            LEFT_RIGHT_S: "left_right_s",
            MAP: "map",
            TABLE: "table",
            CENTER: "center",
            TAGTITLE: "tag_title",
            TAGCONTENT: "tag_content",
            TAGS: "tag_tags"
        };

        var formatTitleItem = function (item, info) {
            var array = [];
            defaultModel(array);
            switch (item.font) {
                case "normal":
                    defaultFont(array);
                    break;
                default :
                    largeFont(array);
                    break;
            }
            switch (item.align) {
                case "left":
                    left(array);
                    break;
                case "right":
                    right(array);
                    break;
                default :
                    center(array);
                    break;
            }
            addArray2array(array, toBytes(item.value));
            lineFeed(array);
            defaultModel(array);
            return array;
        };

        var formatLineItem = function (item, info) {
            var array = [];
            defaultModel(array);
            _.each(item.contents, function (content) {
                switch (content.font) {
                    case "large":
                        largeFont(array);
                        break;
                    default :
                        defaultFont(array);
                        break;
                }
                addArray2array(array, toBytes(content.value));
            });
            lineFeed(array);
            defaultModel(array);
            return array;
        };

        var formatLeftRight = function (item, info) {
            var array = [], multiple = 1,
                spaceWidth = 0,
                leftWidth = parseWidth(item.left.value.text, item.left.font),
                rightWidth = parseWidth(item.right.value.text, item.right.font),
                totalWidth = leftWidth + rightWidth;
            switch (item.left.font) {
                case "large":
                    largeFont(array);
                    break;
                default :
                    defaultFont(array);
                    break;
            }
            addArray2array(array, toBytes(item.left.value));
            defaultFont(array);
            if ((totalWidth % info.width) == 0) {
                plusSpace(4, array);
            } else {
                while (info.width * multiple < totalWidth) {
                    multiple += 1;
                }
                spaceWidth = info.width * multiple - totalWidth;
                if (multiple > 1 && spaceWidth > 4) {
                    spaceWidth = 4;
                }
                plusSpace(spaceWidth, array);
            }

            switch (item.right.font) {
                case "large":
                    largeFont(array);
                    break;
                default :
                    defaultFont(array);
                    break;
            }
            addArray2array(array, toBytes(item.right.value));
            lineFeed(array);
            defaultModel(array);
            return array;
        };

        var formatLeftRights = function (lrs, info) {
            var array = [];
            _.each(lrs.items, function (item) {
                addArray2array(array, formatLeftRight(item, info));
            });
            return array;
        };

        var formatMap = function (map, info) {
            var array = [], width = info.width, pairs = [], firstWidth, secondWith, totalWidth;
            defaultModel(array);
            _.each(map.items, function (item, index) {
                if (item.oneline) {
                    addArray2array(array, toBytes(item.key.value));
                    array.push(CONST.COLON);
                    addArray2array(array, toBytes(item.value.value));
                    lineFeed(array);
                } else {
                    pairs.push(item);
                }
                if (pairs.length == 2) {
                    firstWidth = parseWidth(pairs[0].key.text + ":" + pairs[0].value.text);
                    secondWith = parseWidth(pairs[1].key.text + ":" + pairs[1].value.text);
                    totalWidth = firstWidth + secondWith + 1;

                    addArray2array(array, toBytes(pairs[0].key));
                    array.push(CONST.COLON);
                    addArray2array(array, toBytes(pairs[0].value));
                    if (totalWidth <= width) {
                        plusSpace(width - firstWidth - secondWith, array)
                    } else if (firstWidth <= width && secondWith <= width) {
                        array.push(CONST.LF);
                    } else if (firstWidth > width) {
                        totalWidth = (firstWidth + secondWith) % width + 1;
                        if (totalWidth <= width) {
                            plusSpace(width - totalWidth - 1, array)
                        }
                    }
                    addArray2array(array, toBytes(pairs[1].key));
                    array.push(CONST.COLON);
                    addArray2array(array, toBytes(pairs[1].value));
                    array.push(CONST.LF);
                    pairs = [];
                } else if ((pairs.length == 1) && (index == map.items.length - 1)) {
                    addArray2array(array, toBytes(pairs[0].key));
                    array.push(CONST.COLON);
                    addArray2array(array, toBytes(pairs[0].value));
                    lineFeed(array);
                }

            });
            defaultModel(array);
            return array;
        };
        var formatTag = PrinterUtil.formatTag = function (list, info) {
            var array = [];
            setSize(array, info.width, info.height);
            setGap(array, info.gap);
            setSpeed(array);
            setDensity(array);
            setDirection(array);
            setTearOff(array, info.autoPeel);
            setPeelOn(array, info.autoPeel);
            CLS(array);
            _.each(list, function (item,index) {
                switch (item.format) {
                    case FORMATS.TAGTITLE:
                        var data = [];
                        addArray2array(data,  item.items[0].left.value.bytes);
                        data.push(CONST.COLON);
                        data=arrayToLabelArray(data,toBytes(item.items[0].right.value));
                        array = textTitle(array, data,index);
                        break;
                    case FORMATS.TAGCONTENT:
                        array = textContent(array, item.items[0].content.value.bytes,index);
                        break;
                    case FORMATS.TAGS:
                        array = textTags(array, item.items,index);
                        break;
                }
            });
            printContent(array);
            return array;
        };
        var formatCenter = function(item,info){
            var array = [];
            defaultModel(array);
            center(array);
            _.each(item.items, function (item) {
                addArray2array(array, toBytes(item.values));
                lineFeed(array);
                array.push(29, 42, 25, 25);
                addArray2array(array, item.images);
                array.push(29, 47, 3);
                lineFeed(array);
            });
            return array;
        };
        var formatTable = function (table, info) {
            var array = [], width = info.width,
                margin = info.margin, flexIndex = table.flexIndex,
                itemWidth = 0, leftWidth = 0, maxArray = [], previousUsed = 0,
                index, cutResult, toNextLine;
            for (index = 0; index < table.size; index++) {
                maxArray.push({width: 0, startIndex: 0});
            }
            defaultModel(array);
            _.each(table.header.items, function (item, index) {
                if (index == flexIndex) {
                    return;
                }
                itemWidth = parseWidth(item.value.text);
                if (maxArray[index].width < itemWidth) {
                    maxArray[index].width = itemWidth;
                }
            });
            _.each(table.body.trs, function (tr) {
                _.each(tr.items, function (item, index) {
                    if (index == flexIndex) {
                        return;
                    }
                    itemWidth = parseWidth(item.value.text);
                    if (maxArray[index].width < itemWidth) {
                        maxArray[index].width = itemWidth;
                    }
                });
            });
            _.each(maxArray, function (max) {
                leftWidth += max.width;
            });
            leftWidth += margin * (table.size - 1);
            maxArray[flexIndex].width = width - leftWidth;
            _.each(maxArray, function (max, index) {
                maxArray[index].startIndex = previousUsed;
                previousUsed += maxArray[index].width + margin;
            });
            _.each(table.header.items, function (item, index) {
                itemWidth = parseWidth(item.value.text);
                if (index == table.header.items.length - 1) {
                    if (maxArray[index].width > itemWidth) {
                        plusSpace(maxArray[index].width - itemWidth, array);
                    }
                    addArray2array(array, toBytes(item.value));
                } else {
                    addArray2array(array, toBytes(item.value));
                    if (maxArray[index].width > itemWidth) {
                        plusSpace(maxArray[index].width - itemWidth, array);
                    }
                    plusSpace(1, array);
                }
            });
            lineFeed(array);
            plusLine(info.width, array);
            _.each(table.body.trs, function (tr) {
                if (toNextLine) {
                    addArray2array(array, formatLineItem(toNextLine, info));
                    toNextLine = null;
                }
                _.each(tr.items, function (item, index) {
                    itemWidth = parseWidth(item.value.text);
                    if (index == flexIndex && itemWidth > maxArray[index].width) {
                        cutResult = cutBytes(item.value, maxArray[index].width);
                        if (cutResult.cut.bytes.length > 0) {
                            toNextLine = {contents: [
                                {value: cutResult.cut}
                            ]};
                        }
                        addArray2array(array, toBytes(cutResult.left));
                        plusSpace(1, array);
                    } else {
                        if (index == table.header.items.length - 1) {
                            if (maxArray[index].width > itemWidth) {
                                plusSpace(maxArray[index].width - itemWidth, array);
                            }
                            addArray2array(array, toBytes(item.value));
                        } else {
                            addArray2array(array, toBytes(item.value));
                            if (maxArray[index].width > itemWidth) {
                                plusSpace(maxArray[index].width - itemWidth, array);
                            }
                            plusSpace(1, array);
                        }
                    }
                });
                lineFeed(array);
            });
            if (toNextLine) {
                addArray2array(array, formatLineItem(toNextLine, info));
                toNextLine = null;
            }
            defaultModel(array);
            return array;
        };

        var formatForAndroid = PrinterUtil.formatForAndroid = function (list, info,isWoyou) {
            var array = [],printType;
            var printerShouldPrint = 0;
            var itemShouldPrint = false;
            _.each(list, function (item) {
                switch (item.format) {
                    case FORMATS.TITLE:
                        addArray2array(array, formatTitleItem(item, info));
                        break;
                    case FORMATS.LINE:
                        addArray2array(array, formatLineItem(item, info));
                        break;
                    case FORMATS.LEFT_RIGHT:
                        addArray2array(array, formatLeftRight(item, info));
                        break;
                    case FORMATS.LEFT_RIGHT_S:
                        if (info.tagsAll) {
                            if (item.dispatch) {
                                printType = item.dispatch;
                                if (info.tags && info.tags.length > 0) {
                                    if (item.tags && item.tags.length == 0) {
                                        return array;
                                    }
                                    _.each(info.tags, function (tag) {
                                        if (_.some(item.tags, function (lrsTag) {
                                                return lrsTag == tag;
                                            })) {
                                            itemShouldPrint = true;
                                        }
                                    });
                                } else {
                                    itemShouldPrint = true;
                                }
                            } else {
                                itemShouldPrint = true;
                            }
                        } else {
                            itemShouldPrint = true;
                        }
                        printerShouldPrint += itemShouldPrint?1:0;
                        if (itemShouldPrint) {
                            if (!item.noLeadLine) {
                                plusLine(info.width, array);
                            }
                            addArray2array(array, formatLeftRights(item, info));
                        }
                        break;
                    case FORMATS.MAP:
                        if (!item.noLeadLine) {
                            plusLine(info.width, array);
                        }
                        addArray2array(array, formatMap(item, info));
                        break;
                    case FORMATS.TABLE:
                        if (!item.noLeadLine) {
                            plusLine(info.width, array);
                        }
                        addArray2array(array, formatTable(item, info));
                        break;
                    case FORMATS.CENTER:
                        addArray2array(array, formatCenter(item, info));
                        break;
                    default:
                        break;
                }
            });
            //CUT PAPER
            if (list.length > 0) {
                lineFeed(array);
                if(!isWoyou){
                    lineFeed(array);
                    lineFeed(array);
                    lineFeed(array);
                    paperCut(array);
                }
            }
            if (info.tagsAll) {
                if (printType && printerShouldPrint==0) {
                    array = [];
                }
            }
            return array;
        };
        var format = function (list, info) {
            var array = [],printType;
            var printerShouldPrint = 0;
            var itemShouldPrint = false;
            _.each(list, function (item) {
                itemShouldPrint = false;
                switch (item.format) {
                    case FORMATS.TITLE:
                        addArray2array(array, formatTitleItem(item, info));
                        break;
                    case FORMATS.LINE:
                        addArray2array(array, formatLineItem(item, info));
                        break;
                    case FORMATS.LEFT_RIGHT:
                        addArray2array(array, formatLeftRight(item, info));
                        break;
                    case FORMATS.LEFT_RIGHT_S:
                        if (info.tagsAll) {
                            if (item.dispatch) {
                                printType = item.dispatch;
                                if (info.tags && info.tags.length > 0) {
                                    if (item.tags && item.tags.length == 0) {
                                        return array;
                                    }
                                    _.each(info.tags, function (tag) {
                                        if (_.some(item.tags, function (lrsTag) {
                                                return lrsTag == tag;
                                            })) {
                                            itemShouldPrint = true;
                                        }
                                    });
                                } else {
                                    itemShouldPrint = true;
                                }
                            } else {
                                itemShouldPrint = true;
                            }
                        } else {
                            itemShouldPrint = true;
                        }
                        printerShouldPrint += itemShouldPrint?1:0;
                        if (itemShouldPrint) {
                            if (!item.noLeadLine) {
                                plusLine(info.width, array);
                            }
                            addArray2array(array, formatLeftRights(item, info));
                        }
                        break;
                    case FORMATS.MAP:
                        if (!item.noLeadLine) {
                            plusLine(info.width, array);
                        }
                        addArray2array(array, formatMap(item, info));
                        break;
                    case FORMATS.TABLE:
                        if (!item.noLeadLine) {
                            plusLine(info.width, array);
                        }
                        addArray2array(array, formatTable(item, info));
                        break;
                    case FORMATS.CENTER:
                        addArray2array(array, formatCenter(item, info));
                        break;
                    default:
                        break;
                }
            });
            //CUT PAPER
            if (list.length > 0) {
                lineFeed(array);
                lineFeed(array);
                lineFeed(array);
                paperCut(array);
            }
            if (info.tagsAll) {
                if (printType && printerShouldPrint==0) {
                    array = [];
                }
            }
            var buffer = new ArrayBuffer(array.length);
            var longInt8View = new Uint8Array(buffer);

            for (var i = 0; i < longInt8View.length; i++) {
                longInt8View[i] = array[i];
            }
            return buffer;
        };
        var addArray2array = function (toAdded, added) {
            while (added.length > 0) {
                toAdded.push(added.shift());
            }
        };

        var printUsb = PrinterUtil.printUsb = function (device, data) {
            var bytes = format(data, device.info);
            return UsbPrinterLoader.print(bytes, device.printer);
        };

        var isOnlineUsb = PrinterUtil.isOnlineUsb = function (device) {
            return UsbPrinterLoader.isOnline(device.printer);
        };

        var printNetwork = PrinterUtil.printNetwork = function (device, data) {
            var bytes = format(data, device.info);
            return NetworkPrinterLoader.print(bytes, device.printer);
        };

        var isOnlineNetwork = PrinterUtil.isOnlineNetwork = function (device) {
            return NetworkPrinterLoader.isOnline(device.printer);
        };

        var shouldPrint = PrinterUtil.shouldPrint = function (printer, info) {
            var label = info.type, tags = info.tags, contained,
                shouldPrintForType = false, shouldPrintForTags = false;
            if (_.isString(printer.types) && printer.types == 'all') {
                shouldPrintForType = true;
            } else if (_.isArray(printer.types)) {
                shouldPrintForType = _.any(printer.types, function (type) {
                    return type == label;
                });
            } else if (_.isObject(printer.types)) {
                shouldPrintForType = printer.types[label];
            }
            if (!shouldPrintForType) {
                return false;
            }
            if (info.tags && (info.tags.length > 0) && printer.tags && (printer.tags.length > 0)) {
                contained = _.any(printer.tags, function (it) {
                    return _.any(info.tags, function (tag) {
                        return tag == it;
                    });
                });
            } else {
                contained = true;
            }
            if (contained) {
                shouldPrintForTags = true;
            }
            return shouldPrintForTags;
        };
        return PrinterUtil;
    }).call(window);
};

let exportedValue = main($, _, Backbone, DbRecorder, i18n, POS);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/utils/PrinterUtil.js